// Removes one-shot parameters (e.g. ?offerId= from a link or a notification)
// from the address bar without navigating: App.vue keys <keep-alive> on
// route.fullPath, so a router.replace() would switch to another component
// instance and lose the panel that was just opened.
export const dropQueryParams = (...names) => {
  const url = new URL(window.location.href);
  names.forEach((name) => url.searchParams.delete(name));
  window.history.replaceState(
    window.history.state,
    "",
    `${url.pathname}${url.search}${url.hash}`,
  );
};
